import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// The backend's exact whitelist for the business-case call —
// `VIOPreDefinedValueValidator(['VoPay portal only', 'API focused', 'API + VoPay portal combined'])`.
const PLATFORM_USAGE_VALUES = ['VoPay portal only', 'API focused', 'API + VoPay portal combined'] as const;

export type PlatformUsage = (typeof PLATFORM_USAGE_VALUES)[number];

/**
 * The Platform Usage options for the business-case call. The values double as logic keys and only
 * the rendered labels are localized.
 */
export default function usePlatformUsageOptions(): { value: PlatformUsage; label: string }[] {
  const { t } = useTranslation('translations', { keyPrefix: 'PartnerAccountCreation.Settings.PlatformUsage' });

  return useMemo(() => {
    const labels: Record<PlatformUsage, string> = {
      'VoPay portal only': t('portalOnly', { defaultValue: 'VoPay Portal only' }),
      'API focused': t('apiFocused', { defaultValue: 'API focused' }),
      'API + VoPay portal combined': t('apiAndPortalCombined', { defaultValue: 'API + VoPay Portal combined' }),
    };

    return PLATFORM_USAGE_VALUES.map((value) => ({ value, label: labels[value] }));
  }, [t]);
}
